import { render, staticRenderFns } from "./WpUserActivityDayLogs.vue?vue&type=template&id=65a16429&"
import script from "./WpUserActivityDayLogs.vue?vue&type=script&lang=js&"
export * from "./WpUserActivityDayLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports